import { UI } from '../UI';
import { App } from '../App';
import { Common } from '../Common';
import { User } from '../User';
import { Artworks } from '../../pages/Artworks';
import { Trims } from '../../pages/Trims';
import { MockupCompare } from '../MockupCompare';
import { addFileDialog } from './addFileDialog';
import { existNameDialog } from './existNameDialog';
import { errorDialog } from './errorDialog';
import { Canvas } from './Canvas';

import './scss/designStudio.scss';

export const DesignStudio = (function () {
  let $DSData,
    $DSItem,
    $Side = 0,
    $Color = null,
    $ArtHistory = {};

  const mapping = {
    info: (data) => {
      data.panels.forEach((side) => {
        let selected = side.areas.find((area) => area.frame != null && area.art != null) || null;
        let frame = selected?.frame ? $.extend(true, {}, selected.frame) : null;
        let panelType = selected?.panelType || side.areas[0].panelType;
        side.frame = frame;
        side.selectedPanelType = panelType;
        side.originalPanelType = panelType;
        side.areas.forEach((area) => {
          area.frame = frame;
          if (selected && (area.art == null || area.art.w == 0 || area.art.h == 0)) {
            const artsize = {
              width: selected.art.w,
              height: selected.art.h
            };
            area.art = {
              ...selected.art,
              ...getBoundedBox(artsize, area.area)
            };
          }
          area.originalart = $.extend(true, {}, area.art);
          area.originalarea = $.extend(true, {}, area.area);
        });
      });
      return data;
    },
    item: (data) => {
      return data;
    },
    canvasData: (side) => {
      let sideIdx = side.side;
      return {
        ...side,
        ...{
          elemID: 'ds_side_' + sideIdx,
          selectedVariant: getSelectedVariant(side),
          selectedPanel: getSelectedPanel(side),
          onChange: (out) => onChangeHandler(sideIdx, out),
          onAdd: (out) => onAddHandler(sideIdx, out)
        }
      };
    },
    updateCanvasData: (side) => {
      return {
        ...side,
        ...{
          selectedVariant: getSelectedVariant(side),
          selectedPanel: getSelectedPanel(side)
        }
      };
    },
    compareVariants: (variants) => {
      return variants.filter((v) => v.compareFile !== null);
    },
    frame: (data, type = 0) => {
      return {
        title: data.title,
        brand: data.brand,
        subbrand: data.subbrand,
        standartId: data.standartId,
        objectId: data.id,
        frameType: type,
        files: data.files,
        thumbnailImageUri: data.thumbnailImageUri
      };
    },
    addart: (frame, side, frameType) => {
      side.areas.forEach((area) => {
        area.frame = mapping.frame(frame, frameType);
        area.art = mapping.art(frame, area);
        area.originalart = $.extend(true, {}, area.art);
        area.originalarea = $.extend(true, {}, area.area);
      });
      return side;
    },
    removeart: (side) => {
      side.areas.forEach((area) => {
        area.frame = null;
        area.art = null;
      });
      return side;
    },
    art: (data, selectedPanel) => {
      if (!data) return null;
      // Check if Thumbnails files exist
      const artFile = data.thumbnailMediaFiles?.length
        ? _.findWhere(data.thumbnailMediaFiles, { fileType: 17 })
        : _.findWhere(data.files, { fileType: 1 });

      let outdata = { w: 0, h: 0, x: 0, y: 0, a: 0, uri: artFile?.uri || '' };
      if (artFile && artFile.additionalValues) {
        outdata = {
          ...outdata,
          ...(!!data.size
            ? getBoundedBoxWithSize(artFile.additionalValues, selectedPanel.area, data.size)
            : getBoundedBox(artFile.additionalValues, selectedPanel.area))
        };
      }
      return outdata;
    },
    saveData: ({ newName = null } = {}) => {
      let panels = $.extend(true, [], $DSData.panels);
      let data = [];
      panels.forEach((pan) => {
        let selectedPanel = $.extend(true, {}, getSelectedPanel(pan));
        let variants = pan.variants
          .filter((variant) => variant.compareFile !== null)
          .map((variantWithFile) => ({
            color: variantWithFile.color,
            colorHex: variantWithFile.colorHex,
            File: variantWithFile.compareFile
          }));
        if (selectedPanel.art) {
          if (selectedPanel.art.moved != undefined) {
            delete selectedPanel.art.moved;
          }
          data.push({
            side: pan.side,
            panelType: selectedPanel.panelType,
            area: {
              w: selectedPanel.art.w,
              h: selectedPanel.art.h,
              x: selectedPanel.art.x,
              y: selectedPanel.art.y,
              a: selectedPanel.art.a,
              fixedSize: !!selectedPanel.area.fixedSize
            },
            frame: {
              objectId: selectedPanel.frame.objectId,
              frameType: selectedPanel.frame.frameType
            },
            variants
          });
        }
      });
      return {
        accountId: User.accountID(),
        newName: newName,
        panels: data
      };
    }
  };

  const page = (id) => {
    UI.block('body');

    $Side = 0;
    $Color = null;

    $.when(App.ajaxData(`prelistings/${User.accountID()}/${id}`), App.ajaxData(`DesignStudio/mockup/information/${User.accountID()}/${id}`)).done(function (
      item,
      info
    ) {
      $DSItem = mapping.item(item.object);
      $DSData = mapping.info(info.createdObject);

      // Query Params
      let queryColor = Common.gup('color');
      let querySide = Common.gup('side');
      let queryPanel = Common.gup('panel');
      if (queryColor) {
        $Color = queryColor;
      }
      if (querySide) {
        $Side = querySide;
      }

      if (queryPanel) {
        setSelectedPanel(queryPanel, $Side);
      }

      const templateData = {
        $lang: $Lang,
        itemID: id,
        product: $DSItem,
        info: $.extend(true, {}, $DSData),
        selected: {
          color: $Color,
          side: $Side,
          panel: queryPanel
        }
      };

      let template = require('./tmpl/page.hbs');
      UI.page(template, templateData).then(() => {
        pageinit($DSData);
      });
    });
  };

  const pageinit = (data) => {
    $('#page')
      .off()
      .on('click', '.js-action-dstudio-addexternalfile', addExternalFile)
      .on('click', '.js-action-dstudio-save', save)
      .on('click', '.js-action-dstudio-cancel', goBack)
      .on('click', '.js-action-toggleFixedDimensions', toggleFixedDimensions);

    if (!data.panels.length) {
      return;
    }

    data.panels.forEach((side) => {
      let data = mapping.canvasData(side);
      let canvas = new Canvas(data);
      canvas.create();
      side.canvas = canvas;
    });

    sidebarInit();
  };

  /*
   **  SIDEBAR
   */

  const sidebarInit = () => {
    // Panels change
    $('.js-action-panelswitcher').select2().on('change', panelSwitch);

    // Colors change
    $('.js-action-colorswitcher')
      .select2({
        templateResult: formatColors,
        templateSelection: formatColors
      })
      .on('select2:select', colorSwitch);

    sideSwitcherInit();

    pageDataUpdate();
    setSizesAndLocations(getSide(), getSelectedSide()?.sizesAndLocations);
  };

  const sideSwitcherInit = () => {
    $('.d-studio-side-link').on('click', (e) => {
      let side = $(e.target).data('side');
      if (side == undefined) return;
      $('.d-studio-side-link.active').removeClass('active');
      $('.d-studio-side-tab.active').removeClass('active');
      $('.d-studio-sidebar-tab:not(".d-studio-sidebar-sizesAndLocations-tab").active').removeClass('active');
      $(e.target).addClass('active');
      $(`#ds_side_${side}`).addClass('active');
      $(`#ds_sidebar_${side}`).addClass('active');
      setSide();

      const panels = App.pageData('info.panels');
      const selectedSide = panels.find((p) => p.side * 1 === $Side * 1);
      if (selectedSide?.areas?.some(a => a.art)) {
        setSizesAndLocations(getSide(), selectedSide?.sizesAndLocations);
      }
    });
  };

  const panelSwitch = (e) => {
    const panelType = $(e.target).val();
    if (panelType == undefined) return;

    setSelectedPanel(panelType);

    updateSizesAndLocations();

    canvasRedrawArt();
  };

  const colorSwitch = (e) => {
    const color = $(e.target).val();
    if (!color) return;
    $Color = color;

    $('.js-action-colorswitcher').val(color).trigger('change');

    replaceState('color', color);

    canvasRedrawBlank();
  };

  /*
   **  Canvas draw && update
   */

  const canvasRedrawArt = () => {
    let side = getSelectedSide();
    let data = mapping.updateCanvasData(side);
    side.canvas.redrawArt(data);
  };

  const canvasRedrawBlank = () => {
    $DSData.panels.forEach((side) => {
      let data = mapping.updateCanvasData(side);
      side.canvas.redrawBlank(data);
    });
  };

  const canvasUpdate = (panelType = null) => {
    if (panelType !== null) {
      let side = getSelectedSide();
      if (!side) return;

      side.selectedPanelType = panelType;

      let data = mapping.updateCanvasData(side);
      side.canvas.update(data);
    } else {
      $DSData.panels.forEach((side) => {
        let data = mapping.updateCanvasData(side);
        side.canvas.update(data);
      });
    }
    pageDataUpdate();
  };

  /*
   **  ONCHANGE Update
   */

  const onChangeHandler = (side, art) => {
    if (art === null) {
      mapping.removeart(getSelectedSide());
      $('.js-action-panelswitcher').prop('disabled', false);
    } else {
      let selectedPanel = getSelectedPanel();
      selectedPanel.art = {
        ...selectedPanel.art,
        ...art
      };
    }

    setSide(side);

    updateSizesAndLocations();
  };

  const pageDataUpdate = () => {
    const selectedPanel = getSelectedPanel();
    const selectedSide = getSelectedSide();
    const compareVariants = mapping.compareVariants(selectedSide.variants);

    App.pageData('selected.side', getSide());
    App.pageData('dstudio.blank', getBlank());
    App.pageData('dstudio.blankVariant', getBlankVariant());
    App.pageData('dstudio.compareVariants', compareVariants);
    App.pageData('dstudio.action_compare', compareMockupDialog);
    App.pageData('dstudio.frame', selectedPanel?.frame || 'clear');
    App.pageData('dstudio.isEmptyFrame', !selectedPanel?.frame);
    App.pageData('unsaved_changes', isChanged());
    App.pageData('dstudio.isFixedDimensionsActive', !!selectedPanel.area.fixedSize);

    $('.js-action-panelswitcher').prop('disabled', selectedPanel?.frame?.frameType > 0 && getSide() < 4);
  };

  /*
   ** SET / GET
   */

  const setSide = (data = false) => {
    if (!data) {
      $Side = $('.d-studio-side-tab.active').data('side');
    } else {
      $Side = data;
    }
    replaceState('side', $Side);
    pageDataUpdate();
  };

  const getSide = () => {
    return $Side;
  };

  const setSelectedPanel = (type, side = false) => {
    const selectedSide = getSelectedSide(side);
    if (!selectedSide.areas.find((a) => a.panelType == type)) {
      type = selectedSide.areas[0].panelType;
    }
    selectedSide.selectedPanelType = type;
    //replaceState('panel', type);
    pageDataUpdate();
  };

  const getSelectedSide = (side = false) => {
    side = side == false ? $Side : side;
    return $DSData.panels.find((p) => p.side * 1 === side * 1);
  };

  const getSelectedPanel = (selectedSide = null) => {
    selectedSide = selectedSide || getSelectedSide();
    const panelType =
      selectedSide.selectedPanelType !== undefined ? selectedSide.selectedPanelType : selectedSide.areas[0].panelType;
    return selectedSide.areas.find((a) => a.panelType * 1 === panelType * 1);
  };

  const getSelectedVariant = (selectedSide = null) => {
    selectedSide = selectedSide || getSelectedSide();
    if ($Color) {
      return selectedSide.variants.find((v) => v.color == $Color);
    } else {
      return selectedSide.variants[0];
    }
  };

  const getBlank = () => {
    return $DSItem.blank;
  };

  const getProduct = () => {
    return App.pageData('product');
  };

  const getBlankVariant = () => {
    let selectedColor = $Color ? $DSItem.blank.variants.find((v) => v.color == $Color) : false;
    return selectedColor ? selectedColor : $DSItem.blank.variants[0];
  };

  const getBoundedBox = (art, area) => {
    let w = art.width * 1;
    let h = art.height * 1;
    area.w = area.w * 1;
    area.h = area.h * 1;

    let scaleW = w / area.w;
    let scaleH = h / area.h;
    let scale = scaleW > scaleH ? scaleW : scaleH;
    h = h / scale;
    w = w / scale;

    let x = 0;
    let y = 0;

    if (area.h > h) {
      y = (area.h - h) / 2;
    }

    if (area.w > w) {
      x = (area.w - w) / 2;
    }

    return {
      x: Math.round(x),
      y: Math.round(y),
      w: Math.floor(w),
      h: Math.floor(h)
    };
  };

  const getBoundedBoxWithSize = (art, area, size) => {
    let w = size.width * 1;
    let h = size.height * 1;
    area.w = area.w * 1;
    area.h = area.h * 1;

    if (w > area.w || h > area.h) {
      return getBoundedBox(art, area);
    }

    let y = (area.h - h) / 2;
    let x = (area.w - w) / 2;

    return {
      x: Math.round(x),
      y: Math.round(y),
      w: Math.floor(w),
      h: Math.floor(h)
    };
  };

  const isChanged = () => {
    let changed = false;
    $DSData.panels.forEach((side) => {
      let selectedPanel = getSelectedPanel(side);
      if (
        selectedPanel.art &&
        (selectedPanel.art.moved || side.originalPanelType * 1 !== selectedPanel.panelType * 1)
      ) {
        changed = true;
      } else if (!selectedPanel.art && !$.isEmptyObject(selectedPanel.originalart)) {
        changed = true;
      } else if (selectedPanel.area.fixedSize !== selectedPanel.originalarea?.fixedSize) {
        changed = true;
      }
      let exfile = side.variants.filter((variant) => variant.compareFile !== null && variant.compareFile.action_remove)
        .length;
      if (exfile) {
        changed = true;
      }
    });
    return changed;
  };

  /*
   ** Adding files and artwork
   */

  const onAddHandler = (side, data) => {
    clearFixedDimensionsFlags();

    UI.block('#page');
    $(document).on('shown.bs.modal', '.modal', shownModal).on('hidden.bs.modal', '.modal', hiddenModal);

    if (side === 4) {
      // - Trims
      let parms = {
        action: 'dialog',
        callback: addTrim,
        typeModal: 'trims',
        trimsonly: true
      };
      return Trims.init(parms);
    } else if (side === 5) {
      // - Hang tags
      let parms = {
        action: 'dialog',
        callback: addHangtag,
        typeModal: 'stamps',
        trimsonly: true
      };
      return Trims.init(parms);
    } else {
      // - Artworks
      let parms = {
        action: 'dialog',
        withTrims: true,
        callback: addArtworkOrTrim
      };
      return Artworks.init(parms);
    }
  };

  const shownModal = () => {
    UI.unblock('#page');
  };

  const hiddenModal = () => {
    $(document).off('shown.bs.modal', '.modal', shownModal).off('hidden.bs.modal', '.modal', hiddenModal);
  };

  const addTrim = () => {
    const selectedTrim = App.pageData('selectTrimAndStampModal');
    if (!selectedTrim) {
      return;
    }

    if ($Side > 3) {
      appendArtwork(selectedTrim, 1);
      App.pageData('selectTrimAndStampModal', 'clear');

      return;
    }

    $.when(App.ajaxData(`Trims/${selectedTrim.id}/src/info`, {}, 'GET', 'application/json', true)).done((res) => {
      if (res?.errorInformation?.errorReason) {
        UI.errorMessage(res?.errorInformation?.errorReason);
        return
      }

      const fullPanelType = 1;

      const selectedSide = getSelectedSide();
      const selectedPanel = selectedSide.areas.find(a => a.panelType === fullPanelType);

      if (!selectedPanel) {
        return;
      }

      if (res.width > selectedPanel.area.w || res.height > selectedPanel.area.h || !res.height || !res.width) {
        UI.errorMessage($lang.error.trimSizeNotValid);
        return;
      }

      $('.js-action-panelswitcher').val(fullPanelType).trigger('change').prop('disabled', true);

      selectedTrim.size = res;
      appendArtwork(selectedTrim, 1);
    });

    App.pageData('selectTrimAndStampModal', 'clear');
  };

  const addHangtag = () => {
    const selectedTrim = App.pageData('selectTrimAndStampModal');
    if (!selectedTrim) {
      return;
    }
    appendArtwork(selectedTrim, 2);

    App.pageData('selectTrimAndStampModal', 'clear');
  };

  const addArtwork = () => {
    const selectedArtwork = App.pageData('selectArtModal');
    if (!selectedArtwork) {
      return;
    }

    appendArtwork(selectedArtwork, 0);

    App.pageData('selectArtModal', 'clear');
  };

  const addArtworkOrTrim = () => {
    const selectedArtwork = App.pageData('selectArtModal');

    if (selectedArtwork?.id) {
      addArtwork();
    } else {
      addTrim();
    }
  };

  const appendArtwork = (art, frameType) => {
    const selectedSide = mapping.addart(art, getSelectedSide(), frameType);
    let selectedPanel = getSelectedPanel();

    selectedSide.canvas.addArt(selectedPanel);
  };

  /*
   **  External Mockup file
   */

  const addExternalFile = () => {
    addFileDialog.mockup({
      data: {},
      ok: (data) => {
        if (data && getSelectedVariant()) {
          data.action_remove = removeExternalFile;
          getSelectedVariant().compareFile = data;
          pageDataUpdate();
        }
      }
    });
  };

  const removeExternalFile = () => {
    UI.deleteConfirm($lang.ministu.Externalmockup).then((ok) => {
      if (ok) {
        getSelectedVariant().compareFile = null;
        pageDataUpdate();
      }
    });
  };

  const compareMockupDialog = (img) => {
    UI.blockPage();
    getSelectedSide()
      .canvas.getPNG()
      .then((png) => {
        UI.unblockPage();
        MockupCompare.compareDialog(img, png, true);
      })
      .catch((mess) => {
        UI.unblockPage();
      });
  };

  /*
   **  Sizes & Locations
   */
  const updateSizesAndLocations = () => {
    const $side = getSide();
    // Check Only Front & Back side
    if ($side > 3) {
      return;
    }

    const selectedPanel = getSelectedPanel();
    // Check Only Artworks
    if (selectedPanel?.frame?.frameType !== 0) {
      return;
    }

    const data = mapping.saveData().panels.filter((side) => side.side == $side)[0];
    if (!data) {
      setSizesAndLocations($side);
      return;
    }

    data.blankStandartId = getBlank().standartId;
    App.pageData('dstudio.sizes_loading', true);

    $.when(App.ajaxData(`DesignStudio/calculate-mockup-real-size/${$DSItem.id}`, data, 'POST')).done((res) => {
      if (res.isSuccess && res.realSizeAndLocations) {
        setSizesAndLocations($side, res.realSizeAndLocations);
      }

      App.pageData('dstudio.sizes_loading', false);
    });
  };

  const setSizesAndLocations = (curside, data = []) => {
    let panels = App.pageData('info.panels');

    panels.forEach((side) => {
      if (side.side == curside) {
        side.sizesAndLocations = getSizesData(data);
      }
    });

    App.pageData('info.panels', panels);

    updateFixedDimensions(curside, data);
  };

  /*
   **  SAVE & return
   */

  const save = ({ newName = null } = {}) => {
    const data = mapping.saveData({ newName });

    /*if (!data?.panels?.length || data?.panels.every((p) => p.frame.frameType !== 0)) {
      noArtworkError();
      return;
    }*/

    UI.block('#page');

    $.when(App.ajaxData(`DesignStudio/save-mockup/${User.accountID()}/${$DSItem.id}`, data, 'POST')).done((res) => {
      UI.unblock('#page');

      if (!res.isSuccess) {
        if (res.errorInformation && res.errorInformation.errorReason) {
          const errorReason = res.errorInformation.errorReason;
          const resNewName = res.errorInformation?.errorData?.newName;

          if (errorReason == $lang.error.namealreadyexists.title) {
            existNameDialog.error({ title: newName || $DSItem.title }, save);
          } else if (errorReason == 'newNameCreated' && resNewName) {
            existNameDialog.confirm({ title: resNewName }, save);
          } else {
            errorDialog.error({ title: errorReason });
          }
        }
        return;
      }

      UI.notify({ text: $lang.alert.SuccessfullySaved, type: 'success' });
      goBack();
    });
  };

  const goBack = () => {
    App.pageData('unsaved_changes', false);
    // Go back to Referer Url
    let referer = Common.gup('ref');
    if (referer) {
      $router.push(referer);
    } else {
      $router.push('/prelistings?restoreQuery');
    }
  };

  /*
   **  UTILS
   */

  const formatColors = (opt) => {
    const optimage = $(opt.element).val();
    const colorHex = $(opt.element).attr('data-colorHex');
    if (!optimage) {
      return false;
    }
    return $(
      `<div class="select2-color-option"><span style="background-color:${(colorHex
        ? colorHex
        : optimage
      ).toLowerCase()}"></span>${optimage}</div>`
    );
  };

  const replaceState = (key, value) => {
    if (value == 0 && !Common.gup(key)) {
      return;
    }
    history.replaceState(
      null,
      document.title,
      Common.addQuerySearchParams(
        [{ key: key, value: value }],
        Common.gup(key) ? Common.removeQueryValues(key, document.location.href) : document.location.href
      )
    );
  };

  const updateFixedDimensions = (curside, data) => {
    if (App.pageData('dstudio.skipFixedDimensionsValidation')) {
      return;
    }

    App.pageData('dstudio.isFixedDimensionsError', false);
    App.pageData('dstudio.isFixedDimensionsErrorW', false);
    App.pageData('dstudio.isFixedDimensionsErrorH', false);

    if (!data?.length) {
      return;
    }

    const isActive = App.pageData('dstudio.isFixedDimensionsActive');

    const minSize = data.reduce((acc, sizeBox) => {
      if (!acc.w || !acc.h) {
        return { w: sizeBox.maxPrintWidth, h: sizeBox.maxPrintHeight };
      }

      if (sizeBox.maxPrintWidth < acc.w && sizeBox.maxPrintHeight < acc.h) {
        return { w: sizeBox.maxPrintWidth, h: sizeBox.maxPrintHeight };
      }

      return acc;
    }, { w: 0, h: 0 });

    let invalidW, invalidH;

    const isDisabled = data.some((sizeBox) => {
      invalidW = sizeBox?.area?.w / 10 > minSize.w;
      invalidH = sizeBox?.area?.h / 10 > minSize.h;

      return invalidW || invalidH;
    });

    if (!isDisabled) {
      $ArtHistory.previousArt = getSelectedPanel().art;
      $ArtHistory.previousRealSizeAndLocations = data;
    }

    App.pageData('dstudio.isFixedDimensionsDisabled', isDisabled);

    if (isActive) {
      App.pageData('dstudio.isFixedDimensionsError', isDisabled);
      App.pageData('dstudio.isFixedDimensionsDisabled', false);

      if (isDisabled) {
        App.pageData('dstudio.isFixedDimensionsErrorW', invalidW);
        App.pageData('dstudio.isFixedDimensionsErrorH', invalidH);

        App.pageData('dstudio.skipFixedDimensionsValidation', true);

        let selectedPanel = getSelectedPanel();
        selectedPanel.art = {
          ...selectedPanel.art,
          ...$ArtHistory.previousArt
        };

        if ($ArtHistory.previousRealSizeAndLocations) {
          setSizesAndLocations(curside, $ArtHistory.previousRealSizeAndLocations);
        }

        canvasRedrawArt();
        App.pageData('dstudio.skipFixedDimensionsValidation', false);
      }
    }
  };

  const toggleFixedDimensions = () => {
    App.pageData('dstudio.isFixedDimensionsActive', !App.pageData('dstudio.isFixedDimensionsActive'));

    const selectedPanel = getSelectedPanel();
    selectedPanel.area.fixedSize = App.pageData('dstudio.isFixedDimensionsActive');

    updateSizesAndLocations();
    App.pageData('unsaved_changes', isChanged());
  };

  const getSizesData = (data) => {
    if (!data) {
      return data;
    }

    const isFixedDimensionsActive = App.pageData('dstudio.isFixedDimensionsActive');
    if (!isFixedDimensionsActive) {
      return data;
    }

    const minMaxSizeBoxes = data.reduce((acc, sizeBox) => {
      if (!acc.min || !acc.max) {
        return { min: sizeBox, max: sizeBox };
      }

      if (sizeBox.maxPrintWidth < acc.min.maxPrintWidth || sizeBox.maxPrintHeight < acc.min.maxPrintHeight) {
        return { ...acc, min: sizeBox };
      }

      if (sizeBox.maxPrintWidth > acc.max.maxPrintWidth || sizeBox.maxPrintHeight > acc.max.maxPrintHeight) {
        return { ...acc, max: sizeBox };
      }

      return acc;
    }, { min: null, max: null });

    if (!minMaxSizeBoxes.max || !minMaxSizeBoxes.min) {
      return data;
    }

    const sizeRange =
      `${minMaxSizeBoxes.min.sizeRange.split('-')[0]} - ${minMaxSizeBoxes.max.sizeRange.split('-')[1]}`;

    return [{
      ...minMaxSizeBoxes.max,
      sizeRange,
      maxPrintWidth: minMaxSizeBoxes.min.maxPrintWidth,
      maxPrintHeight: minMaxSizeBoxes.min.maxPrintHeight
    }];
  };

  const clearFixedDimensionsFlags = () => {
    $ArtHistory = {};

    App.pageData('dstudio.skipFixedDimensionsValidation', false);

    App.pageData('dstudio.isFixedDimensionsError', false);
    App.pageData('dstudio.isFixedDimensionsErrorW', false);
    App.pageData('dstudio.isFixedDimensionsErrorH', false);

    App.pageData('dstudio.isFixedDimensionsActive', false);
    App.pageData('dstudio.isFixedDimensionsDisabled', false);

    let selectedSide = getSelectedSide();
    selectedSide?.areas?.forEach((area) => {
      area.area.fixedSize = false;
    });
  };

  const noArtworkError = () => {
    bootbox.dialog({
      title: $lang.error.noArtwork.title,
      message: $lang.error.noArtwork.message,
      buttons: {
        ok: {
          label: 'OK',
          className: 'btn btn-brand'
        }
      }
    });
  };

  return {
    page
  };
})();
